import { Vue, Component } from 'vue-property-decorator';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { getCityProvinceResidential } from '@/features/shipment/services/shipment.services';
import { safeListedCountryCodes } from '@/features/common/raw';

@Component
export class CityProvinceLookupMixin extends Vue {
  private canAutofillCountryCodes: Array<string> = [...safeListedCountryCodes];

  public async autofillResidential(
    cb: (residential: boolean) => void,
    data: string,
  ): Promise<void> {
    if (!this.canAutofillCountryCodes.includes(this[data].countryCode)) return;

    const { postalCode, countryCode } = this[data];

    if (!postalCode || !countryCode) return;

    const response = await getCityProvinceResidential(countryCode, postalCode);
    if (!response) return;

    cb(response.isResidential);
  }

  public async autofillCityProvince(
    cb: (city: string, province: string, residential: boolean) => void,
    data: string,
  ): Promise<void> {
    if (!this.canAutofillCountryCodes.includes(this[data].countryCode)) return;

    const { postalCode, countryCode } = this[data];
    const response = await getCityProvinceResidential(countryCode, postalCode);
    if (!response) return;

    cb('', '', response.isResidential);

    if (!response.city || !response.province) return;

    if (!this[data].city && !this[data].province) {
      cb(response.city, response.province, response.isResidential);
    }

    const convertUppercase = (str: string): string => {
      return str ? str.toString().toUpperCase() : '';
    };

    const cityUpper = convertUppercase(this[data].city);
    const provinceUpper = convertUppercase(this[data].province);
    const responseCityUpper = convertUppercase(response.city);
    const responseProvinceUpper = convertUppercase(response.province);

    if (cityUpper === responseCityUpper && provinceUpper === responseProvinceUpper) return;

    const dialogData = {
      show: true,
      btnText: 'OK',
      title: this.$t('shipment.postalCodeAndCityDoesNotMatch.title'),
      content: this.$t(
        'shipment.postalCodeAndCityDoesNotMatch.text',
        {
          city1: this[data].city,
          province1: this[data].province,
          city2: response.city,
          province2: response.province,
        },
      ),
    };

    this.$store.commit('toggleConfirmDialog', dialogData);
    eventBus.$once(
      eventNames.CONFIRMATION_DIALOG,
      cb.bind(this, response.city, response.province, response.isResidential),
    );
  }
}
